export function secondsToMillis(sec: number): number {
  return Math.trunc(sec * 1000);
}
